<template>
  <div class="login-bg">
    <div class="login-box">
      <div class="login">
        <div class="login-info">
          <input type="text" name="" v-model="userName" placeholder="请输入账号"/><br/>
          <input type="password" name="" v-model="password" placeholder="请输入密码"/><br/>  
          <input type="button" @click="loginBtn" value="登录" style="height:46px;color:#333;font-size: 24px;cursor: pointer;"/>  
        </div>
        <div class="login-remember">
          <input type="checkbox" name="" id="remember-box"/>
          <span>记住账号</span>
          <a href="#">忘记密码？</a>
        </div>
      </div>
      <div style="text-align: center;padding-top: 26px;">
        <img src="@/assets/images/pic_word.png">
      </div>
    </div>
    <transition name="fade">
      <div class="login-tips" v-show="tips">
        <h2>提示</h2>
        <p>{{tipsContent}}</p>
        <button @click="closeMask">确定</button>
      </div>
    </transition>
    <div class="mask" v-show="tips"></div>
  </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import LoginService from "@/api/LoginService";
import store from '@/store'
export default {
  name:"Login",
  data() {
    return {
      userName:'',
      password:'',
      tips:false,
      tipsContent:''
    };
  },
  mounted() { 
    this.isSaveUserName()
  },
  methods: {
      isSaveUserName(){
        let loginUserNameInfo = JSON.parse(localStorage.getItem('loginUserName'))
        if(loginUserNameInfo) {
          document.getElementById('remember-box').checked=loginUserNameInfo.isSave
          this.userName = loginUserNameInfo.userName
        }
        
      },
      loginBtn(){
        if(document.getElementById('remember-box').checked){
          localStorage.setItem('loginUserName',JSON.stringify({userName:this.userName,isSave:true}))
        }else{
          localStorage.setItem('loginUserName',JSON.stringify({userName:'',isSave:false}))
        }
        LoginService.Login({
          userName:this.userName,
          password:this.password
        }).then(
          res => {
            if (res.status == 200 && res.data.status == 1000) {
              let AccountToken = res.data.data.AccountToken;  
              sessionStorage.setItem("Authorization", AccountToken);   
              LoginService.GetTroopInfo().then(
                res=>{  
                  this.$store.commit("setTroopInfo", res.data.data); 
                  document.title = res.data.data.TroopsName+'-SAS应急单兵作战系统'
                },
                err=>{

                }
              )   
              this.$router.push({ name: "builds" }).catch(err => {console.error(err)});
            } else if (res.status == 200) {
              this.tips=true
              this.tipsContent=res.data.msg
            } else {
              this.tips=true
              this.tipsContent=res.data.msg
            }
          },
          err => {
            if (err && err.stack.indexOf('timeout') > -1) {
              this.$message.warning('请求超时,请重试')
            }
            //this.tips=true
            //this.tipsContent=res.data.msg
          }
        );
      },
      closeMask(){
        this.tips=false
      }
  },
  beforeDestroy(){
  }
}
</script>

<style lang="less">
  .login-bg{
    height:100%;
    background:url(../assets/images/login_bg.png) no-repeat;
    background-size: 100% 100%;
  }
  .login-box{
    position: absolute;
    width:38%;
    right:7%;
    top:24%;
    img{
      width:75%;
    }
  }
  .login{
    background:#4D4D4D;
    width:100%;
    height:340px;
    padding:45px 65px;
  }
  .login-info{
    input{
      text-align: center;
      width:100%;
      height:44px;
      margin:16px 0;
      font-size: 20px;
      border:0;
    }
  }
  .login-remember{
    font-size: 18px;
    color:#fff;
    span{
      float:left;
    }
    a{
      color:#fff;
      float:right;
    }
    input{
      margin-top: 5px;
      float:left;
      margin-right: 10px;
      width:18px;
      height:18px;
    }
  }
  .login-tips{
    position: absolute;
    z-index: 2;
    background:#fff;
    left:50%;
    top:50%;
    margin:-140px 0 0 -200px;
    width:400px;
    height:280px;
    border-radius: 6px;
    h2{
      text-align: center;
      font-size: 24px;
      margin:33px;
    }
    p{
      text-align: center;
      font-size: 20px;
    }
    button{
      background:#3FDB22;
      border-radius: 4px;
      color:#fff;
      width:120px;
      height:50px;
      border:0;
      font-size: 22px;
      position: absolute;
      bottom:24px;
      right:34px;
      cursor: pointer;
    }
  }
  .mask{
    width:100%;
    height:100%;
    position: fixed;
    z-index: 1;
  }
  .fade-enter-active {
    animation: bounce-in .4s;
  }
  .fade-leave-active {
    animation: bounce-in .4s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(.2);
    }
    80% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
</style>